import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../_assets/img/logo.svg';
import { useUser, useRoles } from '../../_hooks';
import Hand from '../../_assets/img/hand.png';

function Header() {
    const user = useUser();
    const { isAgentGrdf } = useRoles(user);

    return (
        <div className={"header"}>
            <div className={"header-inner"}>
                <div className={"header-left"}>
                    <Link to={"/"}>
                        <img src={Logo} alt="GRDF" className={"header-logo"} />
                    </Link>
                </div>
                <div className={"header-center"}>
                    {user && <span className={"bleu header-username"}>
                      Bonjour {user.firstName}
                      <span className={"hand"}>
                        <img src={Hand} alt=""/>
                      </span>
                    </span>}
                </div>
                <div className={"header-right"}>
                    {isAgentGrdf && (
                        <Link to={"/rcg/agent-grdf"} className={"btn btn-agent-grdf"}>
                            <i className={"fa fa-user-shield"}></i> Agent GRDF
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
}

export { Header };
